import {
  RECORD_AUDIT_PAIR_RESOURCE_IDS,
  RecordAuditPairResourceId,
} from '../utils/recordAuditPairResources';
import {useIsLicenceEnabled} from './useIsLicenceEnabled';

/**
 * Record-audit pair target types filtered by tenant license. Mirrors the BE feature
 * mapping (Sales, Workshop, CarRental feature configurators); VEHICLE is core and
 * always offered. SERVICE_ORDER is not feature-mapped on BE, but it is a workshop
 * record, so the workshop license gates it here.
 */
export const useLicensedRecordAuditPairResources = (): RecordAuditPairResourceId[] => {
  const {isSalesModuleEnabled, isWorkshopModuleEnabled, isRentalVehicleModuleEnabled} =
    useIsLicenceEnabled();

  const isResourceLicensed: Record<RecordAuditPairResourceId, boolean> = {
    BUSINESS_CASE: isSalesModuleEnabled,
    SERVICE_CASE: isWorkshopModuleEnabled,
    SERVICE_ORDER: isWorkshopModuleEnabled,
    RENTAL_ORDER: isRentalVehicleModuleEnabled,
    VEHICLE: true,
    INTEREST: isSalesModuleEnabled,
    WORKSHOP_INTEREST: isWorkshopModuleEnabled,
  };

  return RECORD_AUDIT_PAIR_RESOURCE_IDS.filter((resourceId) => isResourceLicensed[resourceId]);
};
